var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66669 3.33334C1.66669 2.89131 1.84228 2.46739 2.15484 2.15483C2.4674 1.84227 2.89133 1.66667 3.33335 1.66667H11.6667C12.1087 1.66667 12.5326 1.84227 12.8452 2.15483C13.1578 2.46739 13.3334 2.89131 13.3334 3.33334V6.66667H16.6667C17.1087 6.66667 17.5326 6.84227 17.8452 7.15483C18.1578 7.46739 18.3334 7.89131 18.3334 8.33334V16.6667C18.3334 17.1087 18.1578 17.5326 17.8452 17.8452C17.5326 18.1577 17.1087 18.3333 16.6667 18.3333H8.33335C7.89132 18.3333 7.4674 18.1577 7.15484 17.8452C6.84228 17.5326 6.66669 17.1087 6.66669 16.6667V13.3333H3.33335C2.89133 13.3333 2.4674 13.1577 2.15484 12.8452C1.84228 12.5326 1.66669 12.1087 1.66669 11.6667V3.33334ZM8.33335 13.3333V16.6667H16.6667V8.33334H13.3334V11.6667C13.3334 12.1087 13.1578 12.5326 12.8452 12.8452C12.5326 13.1577 12.1087 13.3333 11.6667 13.3333H8.33335ZM11.6667 11.6667V3.33334H3.33335V11.6667H11.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.c55132de9f44e72a3ba8fd787351fc82.svg";
export { ForwardRef as ReactComponent };